import { TextField } from '@mui/material';
import { FC } from 'react';
import { unCamelCase } from '../../../../../helpers';
import { ITemplateInputProps } from '../../../../../models';

export const TextboxInput: FC<ITemplateInputProps> = ({ input, value, onChange, isRequired }) => {
  const { sectionName } = input;

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    onChange(e.target.value, input);
  };

  return (
    <TextField
      fullWidth
      size="small"
      label={unCamelCase(sectionName)}
      name={sectionName}
      value={value}
      onChange={handleChange}
      required={isRequired}
    />
  );
};
